// X軸のデフォルト位置
export const pos_x = 0;

// スクロール量
export const scroll_amount = 10;

// スクロールタイマーのインターバル(ミリ秒)
export const timer_interval = 500;
